import { useCallback, useState } from 'react';

import { useSelector } from 'react-redux';

import { PAGE_TYPE_ACTIVITY, PAGE_TYPE_AREA, PAGE_TYPE_PROPERTY } from 'constants/index';
import { getItineraryScheduleSelector } from 'store/itineraryDetails/selectors';
import { useTryToRemindCheckPrimaryImage } from 'utils/itineraries/functions';
import { ITINERARY_STEPS } from 'utils/itineraries/itinerary/map';

export function collectNeededPageIds(items) {
  const NEEDED_PAGE_TYPES = [PAGE_TYPE_PROPERTY, PAGE_TYPE_AREA, PAGE_TYPE_ACTIVITY];

  const getIds = (part) => {
    const res = [];
    if (part?.contentState?.entityMap) {
      Object.values(part?.contentState?.entityMap).forEach((v) => {
        if (NEEDED_PAGE_TYPES.includes(v?.data?.type)) {
          res.push(v?.data?.id);
        }
      });
    }

    return res;
  };

  return items
    .filter((it) => !it._destroy)
    .reduce((acc, cur) => {
      acc.push(...getIds(cur?.accommodation));
      acc.push(...getIds(cur?.details));

      return acc;
    }, []);
}

export function useTryToRemindCheckPrimaryImagesForDetailsTab() {
  const schedule = useSelector(getItineraryScheduleSelector);
  const [initialAreaPropertyPageIds, set] = useState([]);

  const setInitialAreaPropertyPageIds = useCallback(() => {
    set(collectNeededPageIds(schedule.items));
  }, [schedule]);

  const getCurrentAreaPropertyPageIds = useCallback(() => {
    return collectNeededPageIds(schedule.items);
  }, [schedule]);

  const { tryToRemindCheckPrimaryImages } = useTryToRemindCheckPrimaryImage({
    neededLastAvailableStep: ITINERARY_STEPS.LANDING,
    itineraryItemName: 'itinerary',
    initialAreaPropertyPageIds,
    getCurrentAreaPropertyPageIds,
  });

  return {
    setInitialAreaPropertyPageIds,
    tryToRemindCheckPrimaryImages,
  };
}
